module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_5.8309813f.png";